module.exports = __webpack_public_path__ + "assets/delete-note.245b2770.svg";